import React, { useState } from 'react';
import { ButtonTertiary } from '@americanexpress/dls-react';
import { FormattedMessage } from 'react-intl';
import styles from './bannerStyle.scss';
import { useIsMobile } from '../utils';
import QuitModal from './QuitModal';

const NavBarHeader = () => {
  const [show, setShow] = useState(false);
  const isMobile = useIsMobile();
  return (
    <header className={styles.header}>
      <div className={styles.modalHeaderInner}>
        <div className="flex flex-align-center flex flex-justify-center margin-auto">
          {!isMobile && (
          <span className="dls-logo-line-md">
            <img
              src="https://www.aexp-static.com/cdaas/one/statics/@americanexpress/static-assets/2.28.0/package/dist/img/logos/dls-logo-line.svg"
              alt="American Express"
            />
          </span>
          )}
          {isMobile && (
          <span className="dls-logo-stack-xs padding-3-l">
            <img
              src="https://www.aexp-static.com/cdaas/one/statics/@americanexpress/static-assets/2.28.0/package/dist/img/logos/dls-logo-stack.svg"
              alt="American Express"
            />
          </span>
          )}
        </div>
        <div className="buttonContainer">
          <ButtonTertiary
            type="button"
            onClick={() => setShow(true)}
            reactlytics={{ element: 'QuitButton', detail: 'CreditCheck' }}
          >
            <FormattedMessage
              id="leavethepageModal.ExitBtnText"
              defaultMessage="leavethepageModal.ExitBtnText"
            />
          </ButtonTertiary>
        </div>
        {show && <QuitModal setShow={setShow} />}
      </div>
    </header>
  );
};

export default NavBarHeader;
